import { Injectable } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FbAuctionDetailComponent } from './fb-auction-detail.component';
import { FbAuctionDetailConfiguration } from './fb-auction-detail.configuration';
import { HeaderAuctionDetailComponent } from './header-auction-detail/header-auction-detail.component';
import { FbAuctionMultipleDetailComponent } from '../fb-auction-multiple-detail/fb-auction-multiple-detail.component';

@Injectable({
  providedIn: 'root'
})
export class FbAuctionDetailService {

constructor(public dialogService: DialogService) { }

ref: DynamicDialogRef | undefined;

show(value : FbAuctionDetailConfiguration) {

    const isMobile = window.innerWidth <= 800; // Verifica se lo schermo è di dimensioni mobili
    const height = isMobile ? '100vh' : '90vh';

    this.ref = this.dialogService.open(FbAuctionDetailComponent, {
        header: value.batch.Name,
        width: '500px',
        height: height,
        contentStyle: { overflow: 'auto'},
        modal : true,
        breakpoints: {
            '500px': '100vw',
        },
        data: {
            configuration : value,
            dialogService: this.dialogService
        },
        templates: {

            header : HeaderAuctionDetailComponent


        },
        dismissableMask: true
    });

}

showMultiple(value : FbAuctionDetailConfiguration) {

    this.ref = this.dialogService.open(FbAuctionMultipleDetailComponent, {
        header: value.batch.Name,
        width: '500px',
        height: '100vh',
        contentStyle: { overflow: 'auto'},
        modal : true,
        breakpoints: {
            '500px': '100vw',

        },
        data: {
            configuration : value,
            dialogService: this.dialogService
        },
        templates: {

            header : HeaderAuctionDetailComponent


        }
    });

}
}
